import { render, staticRenderFns } from "./povertyNumShow.vue?vue&type=template&id=30b13420&scoped=true&"
import script from "./povertyNumShow.vue?vue&type=script&lang=js&"
export * from "./povertyNumShow.vue?vue&type=script&lang=js&"
import style0 from "./povertyNumShow.vue?vue&type=style&index=0&id=30b13420&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b13420",
  null
  
)

component.options.__file = "povertyNumShow.vue"
export default component.exports